<script setup lang="ts">
    import { onMounted, reactive } from 'vue';
    import { getSmtpServers } from './SmtpServers.access';
    import { SmtpServer } from './SmtpServers.types';

    const state = reactive<{ smtpServers: SmtpServer[]; isLoading: boolean }>({
        smtpServers: [],
        isLoading: false,
    });

    onMounted(async () => {
        state.isLoading = true;
        let servers = await getSmtpServers().finally(() => (state.isLoading = false));
        state.smtpServers = servers;
    });

</script>
<template>
    <div>
        <h3>List SmtpServers</h3>
        <div class="table-responsive">
            <table class="table table-hover text-nowrapX">
                <thead class="c-light">
                    <tr>
                        <th>Name</th>
                        <th>SmtpName</th>
                        <th>Host</th>
                        <th>Bulk uses</th>
                        <th>Transactional uses</th>
                        <th>Virtual MTA (or pool)</th>
                        <th>Dkim Overrides</th>
                    </tr>
                </thead>
                <tbody class="td-align-middle">
                    <tr v-for="server in state.smtpServers" :key="server.SmtpServerId">
                        <td>
                            <router-link :to="{ name: 'SmtpServerDetail', params: { smtpServerId: server.SmtpServerId } }">{{ server.Name }}</router-link>
                        </td>
                        <td>{{ server.SmtpName }}</td>
                        <td>{{ server.Host }}</td>
                        <td>{{ server.ActiveBulk }}</td>
                        <td>{{ server.ActiveTransactional }}</td>
                        <td>{{ server.VirtualMta }}</td>
                        <td>{{ server.DkimOverrides }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<style scoped>
    /* Add any scoped styles here */
</style>
